import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9aa5517"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scan-interface" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-title" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "📱 扫码进出库"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "/app",
      class: "back-btn"
    }, "返回")
  ])
], -1 /* HOISTED */))
const _hoisted_3 = {
  key: 0,
  class: "warehouse-lock"
}
const _hoisted_4 = { class: "warehouse-info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "warehouse-icon" }, "📍", -1 /* HOISTED */))
const _hoisted_6 = { class: "warehouse-code" }
const _hoisted_7 = {
  key: 1,
  class: "draft-banner"
}
const _hoisted_8 = { class: "draft-info" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "draft-icon" }, "📋", -1 /* HOISTED */))
const _hoisted_10 = { class: "draft-detail" }
const _hoisted_11 = { class: "draft-doctype" }
const _hoisted_12 = { class: "draft-docname" }
const _hoisted_13 = { class: "draft-stats" }
const _hoisted_14 = { class: "draft-actions" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 2,
  class: "inventory-toolbar"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "detail-content" }
const _hoisted_21 = { class: "detail-label" }
const _hoisted_22 = { class: "detail-value" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" 头部 "),
    _hoisted_2,
    _createCommentVNode(" 类型选择组件 "),
    _createVNode($setup["TypeSelector"], {
      type: $setup.scanType,
      "onUpdate:type": _cache[0] || (_cache[0] = $event => (($setup.scanType) = $event)),
      subtype: $setup.subType,
      "onUpdate:subtype": _cache[1] || (_cache[1] = $event => (($setup.subType) = $event)),
      onChange: $setup.handleTypeChange
    }, null, 8 /* PROPS */, ["type", "subtype"]),
    _createCommentVNode(" 扫描区域组件 "),
    _createVNode($setup["ScanArea"], {
      ref: "scanAreaRef",
      mode: $setup.scanMode,
      disabled: !$setup.canScan,
      onScan: $setup.handleScan,
      onModeChange: $setup.handleModeChange
    }, null, 8 /* PROPS */, ["mode", "disabled"]),
    _createCommentVNode(" 库位锁定指示器 "),
    ($setup.currentWarehouse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString($setup.currentWarehouse), 1 /* TEXT */)
          ]),
          _createElementVNode("button", {
            class: "unlock-btn",
            onClick: $setup.unlockWarehouse
          }, "解锁")
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 草稿单据指示器 "),
    ($setup.draftDocument)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString($setup.draftDocument.doctype), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_12, _toDisplayString($setup.draftDocument.docname), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_13, _toDisplayString($setup.draftDocument.item_count) + " 行 / " + _toDisplayString($setup.draftDocument.total_qty) + " 件", 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "draft-btn submit-btn",
              onClick: $setup.submitDraft,
              disabled: $setup.isSubmitting
            }, "确认提交", 8 /* PROPS */, _hoisted_15),
            _createElementVNode("button", {
              class: "draft-btn cancel-btn",
              onClick: $setup.cancelDraft,
              disabled: $setup.isSubmitting
            }, "取消", 8 /* PROPS */, _hoisted_16)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 盘点模式工具栏 "),
    ($setup.isInventoryMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("button", {
            class: "inventory-btn",
            onClick: $setup.initFullCount,
            disabled: !$setup.currentWarehouse || $setup.isLoading
          }, " 全仓盘点 ", 8 /* PROPS */, _hoisted_18),
          _createElementVNode("button", {
            class: "inventory-btn",
            onClick: $setup.showStockBalance,
            disabled: !$setup.currentWarehouse
          }, " 查看库存 ", 8 /* PROPS */, _hoisted_19)
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 扫描结果组件 "),
    ($setup.scanResult)
      ? (_openBlock(), _createBlock($setup["ScanResult"], {
          key: 3,
          result: $setup.scanResult,
          onConfirm: $setup.handleResultConfirm
        }, null, 8 /* PROPS */, ["result"]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 历史记录组件 "),
    _createVNode($setup["HistoryList"], {
      history: $setup.scanHistory,
      onClear: $setup.clearHistory,
      onItemClick: $setup.viewHistoryDetail
    }, null, 8 /* PROPS */, ["history"]),
    _createCommentVNode(" 数量输入弹窗 "),
    ($setup.showQtyDialog)
      ? (_openBlock(), _createBlock($setup["QtyDialog"], {
          key: 4,
          item: $setup.pendingItem,
          "max-qty": $setup.maxQty,
          "allow-zero": $setup.isInventoryMode,
          onConfirm: $setup.handleQtyConfirm,
          onCancel: $setup.handleQtyCancel
        }, null, 8 /* PROPS */, ["item", "max-qty", "allow-zero"]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 详情弹窗 "),
    ($setup.showDetailDialog)
      ? (_openBlock(), _createBlock($setup["Dialog"], {
          key: 5,
          title: "扫描详情",
          onClose: _cache[2] || (_cache[2] = $event => ($setup.showDetailDialog = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detailFields, (value, key) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: key,
                  class: "detail-row"
                }, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(key) + ":", 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(value), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 加载指示器 "),
    ($setup.isLoading)
      ? (_openBlock(), _createBlock($setup["LoadingOverlay"], { key: 6 }))
      : _createCommentVNode("v-if", true)
  ]))
}